export default {
  SHOW_NOTIFICATION: 'ui/SHOW_NOTIFICATION',
};
